import ApiHandler from "./ApiHandler";

const SignOut = {
  signOut: async () => await ApiHandler.i.auth().post('/oauth/sign-out', {}),
};

export default  SignOut;